import { RecipientType } from '../../api/consent/types';

export interface RecipientChoice {
    recipientType: RecipientType;
    label: string;
    shown: boolean;
}

export const careTeamOptionsList: RecipientChoice[] = [
    {
        recipientType: 'referringOrg',
        label: 'unknown',
        shown: false,
    },
    {
        recipientType: 'gp',
        label: 'General Practitioner (GP)',
        shown: true,
    },
    {
        recipientType: 'psychiatrist',
        label: 'Psychiatrist',
        shown: true,
    },
    {
        recipientType: 'school',
        label: 'School',
        shown: true,
    },
    {
        recipientType: 'familyMember',
        label: 'Family member',
        shown: true,
    },
    {
        recipientType: 'other',
        label: 'Other',
        shown: true,
    },
];
